import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from '@bwoty-web/ui-kit';
import { UI_SORT_DESCENDING } from '@bwoty-web/ui-kit/icons';
import { useIsGlobetrotter, useIsMobile, useOnClickOutside } from '@bwoty-web/ui-kit/hooks';

import SortPanel from '../shared/sortPanel/SortPanel';

import { sortOrderSelected, sortPanelToggled } from '../../redux/reducers/cruiseList/sort';
import {
  selectIsInspiration,
  selectLabels,
  selectSelectedSortOrder,
  selectSortOptions,
  selectSortPanelIsVisible,
} from '../../redux/selectors/cruiseList';

import './cruiseSortPanel.scss';

// `SortPanel` is shared with hotel-list and package-plus-list and is presentational: it takes a
// `sortAction` prop rather than dispatching, so each view wraps its own dispatch and passes it in.
// That wrapping is what this component exists for.
const CruiseSortPanel = () => {
  const dispatch = useDispatch();
  const isInspiration = useSelector(selectIsInspiration);
  const labels = useSelector(selectLabels);
  const selectedSortOrder = useSelector(selectSelectedSortOrder);
  const sortOptions = useSelector(selectSortOptions);
  const sortPanelIsVisible = useSelector(selectSortPanelIsVisible);

  const wrapperRef = useRef(null);
  const isGlobe = useIsGlobetrotter();
  const isMobile = useIsMobile();
  const enableClickOutSide = sortPanelIsVisible && !isMobile;
  const closeSortPanel = () => dispatch(sortPanelToggled(false));
  const sortBtnElement = document.getElementById('iw-cruise-list__sort-button');
  useOnClickOutside(wrapperRef, closeSortPanel, enableClickOutSide, false, [sortBtnElement]);

  const sortBtnProps = { ...(isMobile && { 'aria-haspopup': 'dialog' }) };
  return (
    !isInspiration && (
      <div className="iw-cruise-list__sort-container">
        <Button
          className="iw-cruise-list__sort-btn"
          id="iw-cruise-list__sort-button"
          onClick={() => dispatch(sortPanelToggled(!sortPanelIsVisible))}
          variant={isGlobe ? 'secondary' : 'secondary-dark'}
          {...sortBtnProps}
        >
          <Icon
            alt=""
            path={UI_SORT_DESCENDING}
            size="xs"
            sizeMobile="xs"
          />
          {labels.sortBtnLabel}
        </Button>
        <SortPanel
          closeSortPanel={closeSortPanel}
          isMobile={isMobile}
          selectedSortOrder={selectedSortOrder}
          sortAction={(sortBy) => dispatch(sortOrderSelected(sortBy))}
          sortOptions={sortOptions}
          sortPanelIsVisible={sortPanelIsVisible}
          wrapperRef={wrapperRef}
        />
      </div>
    )
  );
};

export default CruiseSortPanel;
